/* tslint:disable */
/* eslint-disable */
/**
 * Notes API
 * API for managing notes with tags, mentions and attachments
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonMinimalDto } from './PersonMinimalDto';
import {
    PersonMinimalDtoFromJSON,
    PersonMinimalDtoFromJSONTyped,
    PersonMinimalDtoToJSON,
    PersonMinimalDtoToJSONTyped,
} from './PersonMinimalDto';
import type { ReferentielMinimalDto } from './ReferentielMinimalDto';
import {
    ReferentielMinimalDtoFromJSON,
    ReferentielMinimalDtoFromJSONTyped,
    ReferentielMinimalDtoToJSON,
    ReferentielMinimalDtoToJSONTyped,
} from './ReferentielMinimalDto';
import type { AttachmentDto } from './AttachmentDto';
import {
    AttachmentDtoFromJSON,
    AttachmentDtoFromJSONTyped,
    AttachmentDtoToJSON,
    AttachmentDtoToJSONTyped,
} from './AttachmentDto';
import type { TagNoteDto } from './TagNoteDto';
import {
    TagNoteDtoFromJSON,
    TagNoteDtoFromJSONTyped,
    TagNoteDtoToJSON,
    TagNoteDtoToJSONTyped,
} from './TagNoteDto';
import type { BrokerMinimalDto } from './BrokerMinimalDto';
import {
    BrokerMinimalDtoFromJSON,
    BrokerMinimalDtoFromJSONTyped,
    BrokerMinimalDtoToJSON,
    BrokerMinimalDtoToJSONTyped,
} from './BrokerMinimalDto';
import type { RiskNoteMinimalDto } from './RiskNoteMinimalDto';
import {
    RiskNoteMinimalDtoFromJSON,
    RiskNoteMinimalDtoFromJSONTyped,
    RiskNoteMinimalDtoToJSON,
    RiskNoteMinimalDtoToJSONTyped,
} from './RiskNoteMinimalDto';

/**
 * Response containing note details
 * @export
 * @interface GetNoteResponse
 */
export interface GetNoteResponse {
    /**
     * Unique identifier of the note
     * @type {string}
     * @memberof GetNoteResponse
     */
    id?: string;
    /**
     * Title of the note
     * @type {string}
     * @memberof GetNoteResponse
     */
    title?: string;
    /**
     * Content/body of the note
     * @type {string}
     * @memberof GetNoteResponse
     */
    content?: string;
    /**
     * Due date — date CALENDAIRE ("yyyy-MM-dd" en envoi, ISO sans Z en lecture), jamais de conversion de fuseau
     * @type {string}
     * @memberof GetNoteResponse
     */
    dueDate?: string | null;
    /**
     * 
     * @type {ReferentielMinimalDto}
     * @memberof GetNoteResponse
     */
    priority?: ReferentielMinimalDto;
    /**
     * 
     * @type {ReferentielMinimalDto}
     * @memberof GetNoteResponse
     */
    status?: ReferentielMinimalDto;
    /**
     * Dossier liÃ© (null si note libre ou liÃ©e uniquement Ã  une personne)
     * @type {RiskNoteMinimalDto}
     * @memberof GetNoteResponse
     */
    risk?: RiskNoteMinimalDto | null;
    /**
     * 
     * @type {PersonMinimalDto}
     * @memberof GetNoteResponse
     */
    person?: PersonMinimalDto;
    /**
     * 
     * @type {BrokerMinimalDto}
     * @memberof GetNoteResponse
     */
    broker?: BrokerMinimalDto;
    /**
     * List of tags associated with the note
     * @type {Array<TagNoteDto>}
     * @memberof GetNoteResponse
     */
    tags?: Array<TagNoteDto>;
    /**
     * List of persons mentioned in the note
     * @type {Array<PersonMinimalDto>}
     * @memberof GetNoteResponse
     */
    mentions?: Array<PersonMinimalDto>;
    /**
     * List of attachments
     * @type {Array<AttachmentDto>}
     * @memberof GetNoteResponse
     */
    attachments?: Array<AttachmentDto>;
    /**
     * Creation date of the note
     * @type {Date}
     * @memberof GetNoteResponse
     */
    creationTime?: Date;
    /**
     * Last modification date of the note
     * @type {Date}
     * @memberof GetNoteResponse
     */
    lastModificationTime?: Date | null;
}

/**
 * Check if a given object implements the GetNoteResponse interface.
 */
export function instanceOfGetNoteResponse(value: object): value is GetNoteResponse {
    return true;
}

export function GetNoteResponseFromJSON(json: any): GetNoteResponse {
    return GetNoteResponseFromJSONTyped(json, false);
}

export function GetNoteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNoteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'content': json['content'] == null ? undefined : json['content'],
        'dueDate': json['dueDate'] == null ? undefined : json['dueDate'],
        'priority': json['priority'] == null ? undefined : ReferentielMinimalDtoFromJSON(json['priority']),
        'status': json['status'] == null ? undefined : ReferentielMinimalDtoFromJSON(json['status']),
        'risk': json['risk'] == null ? undefined : RiskNoteMinimalDtoFromJSON(json['risk']),
        'person': json['person'] == null ? undefined : PersonMinimalDtoFromJSON(json['person']),
        'broker': json['broker'] == null ? undefined : BrokerMinimalDtoFromJSON(json['broker']),
        'tags': json['tags'] == null ? undefined : ((json['tags'] as Array<any>).map(TagNoteDtoFromJSON)),
        'mentions': json['mentions'] == null ? undefined : ((json['mentions'] as Array<any>).map(PersonMinimalDtoFromJSON)),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(AttachmentDtoFromJSON)),
        'creationTime': json['creationTime'] == null ? undefined : (new Date(json['creationTime'])),
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : (new Date(json['lastModificationTime'])),
    };
}

export function GetNoteResponseToJSON(json: any): GetNoteResponse {
    return GetNoteResponseToJSONTyped(json, false);
}

export function GetNoteResponseToJSONTyped(value?: GetNoteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'content': value['content'],
        'dueDate': value['dueDate'],
        'priority': ReferentielMinimalDtoToJSON(value['priority']),
        'status': ReferentielMinimalDtoToJSON(value['status']),
        'risk': RiskNoteMinimalDtoToJSON(value['risk']),
        'person': PersonMinimalDtoToJSON(value['person']),
        'broker': BrokerMinimalDtoToJSON(value['broker']),
        'tags': value['tags'] == null ? undefined : ((value['tags'] as Array<any>).map(TagNoteDtoToJSON)),
        'mentions': value['mentions'] == null ? undefined : ((value['mentions'] as Array<any>).map(PersonMinimalDtoToJSON)),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(AttachmentDtoToJSON)),
        'creationTime': value['creationTime'] == null ? undefined : ((value['creationTime']).toISOString()),
        'lastModificationTime': value['lastModificationTime'] == null ? undefined : ((value['lastModificationTime'] as any).toISOString()),
    };
}

